import { perPageOptions } from "../composables/useFacet/perPageOptions";
const facetGetters = {
  getSortOptions(searchData) {
    if (!searchData || !searchData.data || !searchData.data.availableSortingOptions) {
      return {
        options: [],
        selected: ""
      };
    }
    return {
      options: searchData.data.availableSortingOptions,
      selected: searchData.input.sort
    };
  },
  getProducts(searchData) {
    if (!searchData || !searchData.data || !searchData.data.items) {
      return [];
    }
    return searchData.data.items;
  },
  getAggregations(searchData) {
    if (!searchData || !searchData.data || !searchData.data.aggregations) {
      return [];
    }
    return searchData.data.aggregations;
  },
  getPagination(searchData) {
    var _a, _b, _c, _d, _e;
    const totalPages = (searchData == null ? void 0 : searchData.data) ? Number.isNaN(Math.ceil(searchData.data.total / searchData.input.itemsPerPage)) ? 1 : Math.ceil(searchData.data.total / searchData.input.itemsPerPage) : 1;
    return {
      currentPage: (((_a = searchData == null ? void 0 : searchData.input) == null ? void 0 : _a.page) > totalPages ? 1 : (_b = searchData == null ? void 0 : searchData.input) == null ? void 0 : _b.page) || 1,
      totalPages,
      totalItems: ((_c = searchData == null ? void 0 : searchData.data) == null ? void 0 : _c.total) ? searchData.data.total : 0,
      itemsPerPage: ((_d = searchData == null ? void 0 : searchData.input) == null ? void 0 : _d.itemsPerPage) || 12,
      pageOptions: ((_e = searchData == null ? void 0 : searchData.data) == null ? void 0 : _e.perPageOptions) || perPageOptions
    };
  }
};
var facetGetters_default = facetGetters;
export {
  facetGetters_default as default
};
